import type { Status } from '../../types/Status';
import type { ToastOptions } from './types';

import { getStatusLiveRole } from '../../utils/getStatusLiveRole';

const BASELINE_CHAR_COUNT = 80;
const BASELINE_DURATION_MS = 6000;
const MAX_DURATION_MS = 10000;
const EXTRA_CHAR_BUCKET = 14;
const EXTRA_DURATION_MS = 1000;

export const getAutoDismissDuration = (text: string, title?: string) => {
  const charCount = `${title ?? ''} ${text}`.trim().length;

  if (charCount <= BASELINE_CHAR_COUNT) {
    return BASELINE_DURATION_MS;
  }

  const extraBuckets = Math.ceil(
    (charCount - BASELINE_CHAR_COUNT) / EXTRA_CHAR_BUCKET,
  );

  return Math.min(
    BASELINE_DURATION_MS + extraBuckets * EXTRA_DURATION_MS,
    MAX_DURATION_MS,
  );
};

export const getToastRole = (status: Status): 'alert' | 'status' =>
  getStatusLiveRole(status);

export const resolveToastId = (id?: string | number) =>
  id === undefined ? crypto.randomUUID() : String(id);

export const shouldAutoDismiss = ({
  autoDismiss = true,
  link,
}: Pick<ToastOptions, 'autoDismiss' | 'link'>) => autoDismiss && !link;

export const shouldShowDismissControl = ({
  autoDismiss = true,
  link,
  onDismiss,
}: Pick<ToastOptions, 'autoDismiss' | 'link' | 'onDismiss'>) =>
  onDismiss !== undefined || !shouldAutoDismiss({ autoDismiss, link });
